import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import Servicehome from "./home/servicehome";
import { Footer } from "./common/footer";

function Homepage(){


    return(
<div>
<Topheader></Topheader>


{Homecontent.map((v)=>{

return(
    <Servicehome datainfo={(v)}></Servicehome>
)

})}

<Footer/>




</div>
















 );







    
}
export {Homepage} ;